
export const privateMenu: Menu = {
    categories: [
        {
            i18nKey: 'vehicle',
            insurances: [
                {
                    i18nKey: 'car',
                    i18nLink: 'car_path',
                    iconKey: 'auto'
                },
                {
                    i18nKey: 'motorbike',
                    i18nLink: 'motorbike_path',
                    iconKey: 'moto'
                },
                {
                    i18nKey: 'bicycle', 
                    i18nLink: 'bicycle_path',
                    iconKey: 'bike'
                },
            ],
        },
        {
            i18nKey: 'house',
            insurances: [
                 {
                    i18nKey: 'house',
                    i18nLink: 'house_path',
                    iconKey: 'house'
                }
            ],
        },
        {
            i18nKey: 'family',
            insurances: [
                 {
                    i18nKey: 'civil_liability',
                    i18nLink: 'civil_liability_path',
                    iconKey: 'family'
                },
                {
                    i18nKey: 'hospitalization',
                    i18nLink: 'hospitalization_path',
                    iconKey: 'hospitalization'
                },
                {
                    i18nKey: 'assistance',
                    i18nLink: 'assistance_url',
                    iconKey: 'travel'                        
                }
            ],
        },
        {
            i18nKey: 'pension',
            insurances: [
                 {
                    i18nKey: 'savings', // nl todo
                    i18nLink: 'savings_path', // nl todo
                    iconKey: 'expense'
                },
                {
                    i18nKey: 'independent_pension', // nl todo
                    i18nLink: 'independent_pension_path', // nl todo
                    iconKey: 'expense'                        
                }
            ],
        },

        {
            i18nKey: 'activity',
            insurances: [
                 {
                    i18nKey: 'independent',
                    i18nLink: 'independent_path',
                    iconKey: 'b2b' 
                },
                {
                    i18nKey: 'business',
                    i18nLink: 'business_path',
                    iconKey: 'b2b' 
                }
            ],
        },
    ],
};

export const independentMenu: Menu = {
    categories: [
        {
            i18nKey: 'activity',
            insurances: [
                {
                    i18nKey: 'rc_pro',
                    i18nLink: 'rc_pro_path',
                    iconKey: 'rc'
                },
                {
                    i18nKey: 'rc_exploitation',
                    i18nLink: 'rc_exploitation_path',
                    iconKey: 'rc'
                },
                {
                    i18nKey: 'rc_decennial',
                    i18nLink: 'rc_decennial_path',
                    iconKey: 'rc'
                },
                {
                    i18nKey: 'rc_medical',
                    i18nLink: 'rc_medical_path',
                    iconKey: 'hospitalization',
                    hideNL: true
                },
                {
                    i18nKey: 'rc_objective',
                    i18nLink: 'rc_objective_path',
                    iconKey: 'rc'
                },
                {
                    i18nKey: 'cyber',
                    i18nLink: 'cyber_path',
                    iconKey: 'cyber',
                    hideNL: true
                },
                {
                    i18nKey: 'legal_expenses',
                    i18nLink: 'legal_expenses_path',
                    iconKey: 'pj',
                    hideNL: true
                },
                {
                    i18nKey: 'all_risks',
                    i18nLink: 'all_risks_path',
                    iconKey: 'rc'
                },
            ],
        },
        {
            i18nKey: 'materials',
            insurances: [
                {
                    i18nKey: 'building',
                    i18nLink: 'building_path',
                    iconKey: 'building',
                    hideNL: true
                },
                {
                    i18nKey: 'informatic',
                    i18nLink: 'informatic_path',
                    iconKey: 'cyber',
                    hideNL: true
                },
            ],
        },
        {
            i18nKey: 'employees',
            insurances: [
                {
                    i18nKey: 'work_accident',
                    i18nLink: 'work_accident_path',
                    iconKey: 'accident',
                    hideNL: true
                },
                {
                    i18nKey: 'health',
                    i18nLink: 'health_path',
                    iconKey: 'life_pro',
                    hideNL: true
                },
            ],
        },
        {
            i18nKey: 'mobility',
            insurances: [
                {
                    i18nKey: 'auto',
                    i18nLink: 'auto_path',
                    iconKey: 'auto',
                    hideNL: true
                },
                {
                    i18nKey: 'van',
                    i18nLink: 'van_path',
                    iconKey: 'driver',
                    hideNL: true
                },
            ],
        },
        {
            i18nKey: 'managers',
            insurances: [
                {
                    i18nKey: 'rc_admins',
                    i18nLink: 'rc_admins_path',
                    iconKey: 'admin'
                },
                {
                    i18nKey: 'pension',
                    i18nLink: 'pension_path',
                    iconKey: 'life_pro',
                    hideNL: true
                },
                {
                    i18nKey: 'income',
                    i18nLink: 'income_path',
                    iconKey: 'expense',
                    hideNL: true
                },
                {
                    i18nKey: 'death',
                    i18nLink: 'death_path',
                    iconKey: 'life_pro',
                    hideNL: true
                },
                {
                    i18nKey: 'manager',
                    i18nLink: 'manager_path',
                    iconKey: 'accident',
                    hideNL: true
                },               
            ],
        },
        {
            i18nKey: 'other',
            insurances: [
                 {
                    i18nKey: 'business',
                    i18nLink: 'business_path',
                    iconKey: 'b2b' 
                },
                {
                    i18nKey: 'private',
                    i18nLink: 'private_path',
                    iconKey: 'private' 
                }
            ],
        },
    ],
};

export const businessMenu: Menu = {
    categories: [
        {
            i18nKey: 'activity',
            insurances: [
                {
                    i18nKey: 'rc_pro',
                    i18nLink: 'rc_pro_path',
                    iconKey: 'rc'
                },
                {
                    i18nKey: 'rc_exploitation',
                    i18nLink: 'rc_exploitation_path',
                    iconKey: 'rc'
                },
                {
                    i18nKey: 'rc_decennial',
                    i18nLink: 'rc_decennial_path',
                    iconKey: 'rc'
                },
                {
                    i18nKey: 'rc_objective',
                    i18nLink: 'rc_objectivel_path',
                    iconKey: 'rc'
                },
                {
                    i18nKey: 'rc_voluntary',
                    i18nLink: 'rc_voluntary_path',
                    iconKey: 'rc',
                    hideNL: true
                },                
                {
                    i18nKey: 'cyber',
                    i18nLink: 'cyber_path',
                    iconKey: 'cyber'
                },
                {
                    i18nKey: 'pj',
                    i18nLink: 'pj_path',
                    iconKey: 'pj'
                },
            ],
        },
        {
            i18nKey: 'materials',
            insurances: [
                {
                    i18nKey: 'building',
                    i18nLink: 'building_path',
                    iconKey: 'building'                        
                },
                {
                    i18nKey: 'machine_breakdown',
                    i18nLink: 'machine_breakdown_path',
                    iconKey: 'rc'                        
                },
                {
                    i18nKey: 'transported_good',
                    i18nLink: 'transported_good_path',
                    iconKey: 'rc'                        
                },
                {
                    i18nKey: 'all_risk',
                    i18nLink: 'all_risk_path',
                    iconKey: 'rc'                        
                },
            ],
        },
        {
            i18nKey: 'employees',
            insurances: [
                {
                    i18nKey: 'work_accident',
                    i18nLink: 'work_accident_path',
                    iconKey: 'accident'                        
                },
                {
                    i18nKey: 'health',
                    i18nLink: 'health_path',
                    iconKey: 'hospitalization'                        
                },
                {
                    i18nKey: 'group',
                    i18nLink: 'group_path',
                    iconKey: 'group'                        
                },
            ],
        },
        {
            i18nKey: 'vehicle',
            insurances: [
                {
                    i18nKey: 'cars',
                    i18nLink: 'cars_path',
                    iconKey: 'auto'                        
                },
                {
                    i18nKey: 'truck',
                    i18nLink: 'truck_path',
                    iconKey: 'driver' ,
                    hideNL: true                       
                },
            ],
        },
        {
            i18nKey: 'managers',
            insurances: [
                {
                    i18nKey: 'rc_admins',
                    i18nLink: 'rc_admins_path',
                    iconKey: 'rc'                        
                },
                {
                    i18nKey: 'pension',
                    i18nLink: 'pension_path',
                    iconKey: 'expense'                        
                },
                {
                    i18nKey: 'manager_accident',
                    i18nLink: 'manager_accident_path',
                    iconKey: 'accident'                        
                },
            ],
        },
        {
            i18nKey: 'other',
            insurances: [
                 {
                    i18nKey: 'independent',
                    i18nLink: 'independent_path',
                    iconKey: 'b2b' 
                },
                {
                    i18nKey: 'private',
                    i18nLink: 'private_path',
                    iconKey: 'private' 
                }
            ],
        },
    ],
}; 


// types
interface Insurance {
    i18nKey: string
    i18nLink: string
    iconKey?: string 
    hideNL?: boolean
} 

interface Category {
    i18nKey: string
    insurances: Insurance[]
}

export enum MenuType {
   private = 'private',
   independent = 'independent',
   business = 'business'
}

interface Menu {
    categories: Category[]
}

